import React, {ElementRef} from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerEdit, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
import { cargarCatalogosGenericoAsync, cargarCatalogos_Otros } from '../../funciones_globales/catalogos';
import styled from 'styled-components';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select';
import ModalResponsive from '../componentes_generales/componentes_formulario/modals/modalresponsive';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
import { completar_String, formatearFechaMoment_a_String } from '../../funciones_globales/format';
import { connect } from 'react-redux';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import global_axios from '../../funciones_globales/interaccionapi';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm  } from '../../actions/generales/act_gen03';
import moment from 'moment';
import { InputText } from '../componentes_generales/componentes_formulario/inputs/inputtext';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import { bindActionCreators } from 'redux';
import { validarFechaTransaccionSeleccionada } from '../../funciones_globales/utils';
import { obtenerSecuencial } from '../../funciones_globales/parametros';
import { getItemDatosSesion } from '../../funciones_globales/manejosesion';
import { validarFechaMomentEnFormatoString } from '../../funciones_globales/utils';
import { getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';

const Button = styled.button`
    height: 25px;
    padding: 0px 10px;
    font-size: 11px;
    z-index: 0;
`;

const ContenedorModal = styled.div`  
    margin-top: 20px;
    height: 100%;
    width: 750px;
`;

class FormImport12 extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            //STATES STANDARIZADOS
            secuenciaId: '', //--> Debe cargarse y autogenerarse por cada insert
            operacion: 'G', //G GUARDAR
            permiso: null, //G SOLO GUARDAR => M Guardar & Modificar
            ult_transaccion: null,
            fecha_proceso: null,
            planVigente: null,
            cuentaProveedor: null,            
            proveedor_sel: null,
            articulo_sel: null,

            cantidad: 0,
            pFob: 0,

            //Fechas
            fechaConfirmacion: null,
            fechaEmbarque: null,
            fechaAduana: null,
            fechaRecepcion: null,

            valorFob: 0,

            //Modal
            isOpen: false,
            selectFecha_sel: null,
            fechaSeleccionada_sel: null,
            cantidadDias: 0,
            procentaje: 0,

            //FocusRef
            asyncRef: ElementRef, //ReactSelectAsync
           
            //GRID
            dataModalFormaPago: [],
            columnFormaPago:[  
                                {   header: "",
                                    field: "eliminar",
                                    width: 75,
                                    type: "link_elim"                                                
                                },
                                {   header: "Sec",
                                    field: "secuencia",
                                    width: 50,
                                    type: "string"
                                },
                                {   header: "Tipo",
                                    field: "tipo_fec",
                                    width: 50,
                                    type: "num_entero"
                                },                                      
                                {   header: "Descripción",
                                    field: "descripcion",
                                    width: 160,
                                    type: "string"                       
                                },
                                {   header: "Fecha",
                                    field: "fecha",
                                    width: 75,
                                    type: "string"                       
                                },
                                {   header: "Dias plazo",
                                    field: "dias_plazo",
                                    width: 80,
                                    type: "num_entero_edit",
                                    editable: true                                            
                                },
                                {   header: "Porcentaje",
                                    field: "porcentaje",
                                    width: 80,
                                    type: "num_entero_edit",
                                    editable: true                                               
                                },                                
                                {   header: "Fecha pago",
                                    field: "fecha_pago",
                                    width: 75,
                                    type: "string"                                             
                                },
                                {   header: "Valor a pagar",
                                    field: "fob_base",
                                    width: 75,
                                    type: "num_decimal"                                                
                                }                                        
                            ],
            dataArticulos: [],
            columnDefsArticulos: [
                            {  header: "",
                                field: "eliminar",
                                width: 75,
                                type: "link_elim"                                                
                            },
                            {   header: "Sec",
                                field: "secuencial",
                                width: 55,
                                type: "string"
                            },
                            {   header: "Código",
                                field: "articulo",
                                width: 70,
                                type: "string",
                                
                            },
                            {   header: "Descripción",
                                field: "nombre",
                                width: 350,
                                type: "string"                       
                            },
                            {   header: "Cant.",
                                field: "cantidad",
                                width: 70,
                                type: "num_entero_edit",
                                editable: true                                               
                            },                               
                            {   header: "P. FOB",
                                field: "precio_fob",
                                width: 70,
                                type: "num_decimal",
                                editable: true                                               
                            },
                            {   header: "Subtotal",
                                field: "subtotal",
                                width: 75,
                                type: "num_decimal"                                                
                            },                                
                            {   header: "Arancel",
                                field: "arancel",
                                width: 75,
                                type: "num_entero_edit"                                                
                            }
                        ],

        };

        this.articulosOptions = {
            context: {
                componentParent: this
            },
            enableColResize: true,
            enableCellChangeFlash: true,
            onRowDataChanged:((event)=>{
            }),
            onCellValueChanged:((event)=>{  
            }),
            onCellEditingStarted:((event)=> {
            })
        };

        this.formPagoOptions = {
            context: {
                componentParent: this
            },
            enableColResize: true,
            enableCellChangeFlash: true,
            onRowDataChanged:((event)=>{                
            }),
            onCellValueChanged:((event)=>{ 
                switch (event.colDef.field) {
                    case 'porcentaje':
                        if(event.newValue!==''){
                            let resp = 0;
                            let total = this.getTotalArticulo();
                            resp = (total*parseInt(event.data.porcentaje, 10))/100;
                            event.data.fob_base = resp.toFixed(2);
                        }else{
                            event.data.porcentaje = parseInt(event.oldValue,10);
                        }
                        
                        break;
                    case 'dias_plazo':
                        if(event.newValue!==''){
                            let fechaSumada;
                            let fecha = moment(event.data.fecha, 'DD/MM/YYYY')
                            fechaSumada = fecha.add(parseInt(event.data.dias_plazo, 10), 'days')
                            event.data.fecha_pago = formatearFechaMoment_a_String(fechaSumada)
                        }else{
                            event.data.dias_plazo = parseInt(event.oldValue,10);
                        }
                        break;
                
                    default:
                        break;
                }
                this.apiFormaPago.refreshCells(); 
            }),
            onCellEditingStarted:((event)=>{                
            })
        };
        
        //Properties
        this.actualizarCampos = this.actualizarCampos.bind(this);
        this.addItems = this.addItems.bind(this);
        this.guardarImportacion = this.guardarImportacion.bind(this);
        this.asignarCuentaProveedor = this.asignarCuentaProveedor.bind(this);

        //Modal
        this.toggleModal = this.toggleModal.bind(this);
        this.setFormaPago = this.setFormaPago.bind(this);
        this.addFormaPago = this.addFormaPago.bind(this);

        //GRID
        this.onGridArticulosReady = this.onGridArticulosReady.bind(this);
        this.onGridFormaPagoReady = this.onGridFormaPagoReady.bind(this);
    }

    //Focus para select async
    focusAsync(){
        this.asyncRef.focus();
    }

    //Grid
    onGridArticulosReady(params) {
        this.apiArticulos = params.api;
        this.columnApiArticulos = params.columnApi;
    }

    onGridFormaPagoReady(params) {
        this.apiFormaPago = params.api;
        this.columnApiFormaPago = params.columnApi;
    }

    //Operaciones
    cargarObjetos(ruta){
        return new Promise((resolve, reject) => {
            global_axios.get(ruta)
            .then((response)=>{
                resolve(response.data)
            })
            .catch((err)=>{
                reject(err.toString());
            });
        });
    } 

    actualizarCampos(event){
        const target = event.target;       
        const name = target.name;    
        const value = target.type === 'checkbox'? target.checked : target.value;
        this.setState({
          [name]: value
        });
    }

    addItems(){
        var continuar = true;
        var errors = "";

        if(this.state.articulo_sel===null){
            continuar = false;
            errors = errors+`- Ingrese un articulo\n`
        }

        if(parseInt(this.state.cantidad,10)===0){
            continuar = false;
            errors = errors+`- Ingrese una cantidad\n`
        }

        if(parseFloat(this.state.pFob)===0){
            continuar = false;
            errors = errors+`- Ingrese un precio`
        }

        if(continuar===true){
            let repetido = this.validacionItemsRepetidos(this.state.articulo_sel.value);

            if(repetido===true){
                let msg = window.confirm(`El artículo: ${this.state.articulo_sel.value} ya se encuentra en la importación, ¿añadirlo?` )
                if(msg){
                    this.insertArticulo();
                    this.focusAsync()
                }
            }else{
                this.insertArticulo();
                this.focusAsync();
            }
        }else{
            alert(errors);
        }
    }

    insertArticulo(){
        this.cargarObjetos('/articulos/'+this.state.articulo_sel.value).then((arancel)=>{
            var item = {};
            let nro_item = 0;
            let index_final = this.state.dataArticulos.length-1

            if(index_final===-1){
                nro_item = 1
            }else{
                nro_item = parseInt(this.state.dataArticulos[index_final].secuencial, 10)+1;
            }
            
            item.secuencial = completar_String(nro_item, '0', 3);;
            item.articulo = this.state.articulo_sel.value;
            item.nombre = this.state.articulo_sel.label;
            item.cantidad = this.state.cantidad;
            item.precio_fob = Math.round(parseFloat(this.state.pFob,10)*100)/100;
            item.subtotal = Math.round((item.precio_fob*this.state.cantidad)*100)/100;
            item.arancel = arancel!==null?(arancel.impArancel!==null?arancel.impArancel.Impuesto:null):null

            this.setState({dataArticulos: this.immutablePush(this.state.dataArticulos, item)},()=>{
                let total = this.getTotalArticulo();
                this.setState({valorFob: Math.round(total*100)/100})
            })
        })
    }

    validacionItemsRepetidos(codArticulo){
        let repetido = false;
        this.state.dataArticulos.forEach((DATA)=>{
            if(DATA.articulo===codArticulo){
                repetido = true
            }
        })

        return repetido;
    }

    asignarCuentaProveedor(){

        if(this.state.proveedor_sel!==null){
            this.cargarObjetos('/proveedores?tipo=indt_proveedor&ident='+this.state.proveedor_sel.value).then((provData)=>{
                var cuentaProv = provData[0].Cuenta
                if(cuentaProv!==null){
                    this.cargarObjetos('/cuentas/'+cuentaProv+'/'+this.state.planVigente).then((cuenta)=>{
                        console.log("CUENTA: ", cuenta)
                        this.setState({cuentaProveedor: cuenta!==null?cuenta.Cuenta:null})
                    })
                }
            })
        }
    }

    setFormaPago(){
        if(this.state.selectFecha_sel !== null){
            var selFecha = this.state.selectFecha_sel.value
            if(selFecha==="1"){
                this.setState({fechaSeleccionada_sel: this.state.fechaConfirmacion})
            }else if(selFecha==="2"){               
                this.setState({fechaSeleccionada_sel: this.state.fechaEmbarque})
            }else{
                alert("Tipo de fecha fuera de rango [1 o 2]")
            }
        }
    }

    limpiarPantalla(){
        let fechaProceso = getFechaProcesoPorModulo('03');

        let fechaConfirmacion = moment(fechaProceso, "DD/MM/YYYY");
        let fechaEmbarque =  null
        let fechaAduana =    null
        let fechaRecepcion = null

        this.setState({fecha_proceso: moment(fechaProceso,'DD/MM/YYYY'), 
            cuentaProveedor:null, proveedor_sel: null,
            articulo_sel: null, cantidad: 0, pFob: 0, 
            fechaConfirmacion: fechaConfirmacion, fechaEmbarque: fechaEmbarque, 
            fechaAduana: fechaAduana, fechaRecepcion: fechaRecepcion , dataModalFormaPago: [],
            dataArticulos: [], valorFob: 0})

        this.clearModal();
    }

    //ACCION CRUD
    guardarImportacion(){
        var errors = "";
        var proceder = true;
        var acc=0;

        let fechaProceso = getFechaProcesoPorModulo('03');

        // Validacion de fecha de proceso que se puede cambiar ------------------------------
        if (this.props.permiteCambioFProceso==='S'){
            let resultadoValidFProceso = validarFechaTransaccionSeleccionada(this.state.fecha_proceso, moment(fechaProceso, 'DD/MM/YYYY'), this.props.diasPermiteCambioFProceso);
            if(resultadoValidFProceso.esValida===false){
                proceder = false;
                errors = errors + resultadoValidFProceso.msg+'\n'
            }
        }

        if(this.state.proveedor_sel===null){
            proceder = false;
            errors = errors+`- Ingrese un proveedor\n`
        }

        if(this.state.fechaConfirmacion===null || this.state.fechaEmbarque===null || this.state.fechaAduana===null || this.state.fechaRecepcion===null){
            proceder = false;
            errors = errors+`- Ingrese una de las fechas requeridas\n`
        }

        if(this.state.cuentaProveedor===null){
            proceder = false;
            errors = errors+`- El proveedor no tiene cuenta asociada, imposible continuar\n`
        }

        acc = this.control_porcentaje_pago(this.state.dataModalFormaPago)

        if(acc<100){
            errors = errors+"El porcentaje de pago es inferior al 100%";
        }else if(acc>100){
            errors = errors+"El porcentaje de pago es superior al 100%";
        }

        if(proceder === true && acc===100){
            var data = {};

            data.Localidad = '01';
            data.Tipo = 'N';
            data.Proveedor = this.state.proveedor_sel.value;
            data.FormaPago = 'CR';
            data.FechaInicio = this.state.fechaConfirmacion;
            data.FechaSalida = this.state.fechaEmbarque;
            data.FechaLlegada = this.state.fechaAduana;
            data.FechaRecepcion = this.state.fechaRecepcion;

            data.Importe = 0;
            data.Saldo = 0;
            data.Gasto = 0;
            data.Moneda = JSON.parse(getItemDatosSesion('moneda')).Moneda;
            data.Dolar = JSON.parse(getItemDatosSesion('moneda')).Cotizacion;
            data.Usuario = this.props.usuario;
            data.ConCuenta = this.state.cuentaProveedor;
            data.Status = 'P';
            data.Refrendo = 'C';
            data.ValorFOB = Math.round(this.state.valorFob*100)/100;

            //DetArticulos
            data.detalleImport = this.state.dataArticulos;

            //formaPago
            data.formaPago = this.state.dataModalFormaPago;

            let config_request = {
                method: 'POST',
                url: '/importaciones',
                data
            }

            this.props.cambiar_VisualizacionLoading(true);
            global_axios(config_request)
            .then((response)=>{
                this.props.cambiar_VisualizacionLoading(false);        
                alert(response.data.msg) 
                obtenerSecuencial('Importacion').then((secImportacion)=>{
                    this.setState({secuenciaId: completar_String(secImportacion.codigo,'0',6)})
                })
                this.limpiarPantalla()   
            }) 
            .catch((error)=>{ 
                this.props.cambiar_VisualizacionLoading(false);          
                if (error.response){
                    alert(error.response.data.msg);
                }
            })
        }else{
            alert(errors);
        }
    }

    //Modal Operations
    toggleModal(){
        /* CAPTURA FECHAS PARA VALIDACION */
        let fechaConfirmacion = this.state.fechaConfirmacion===null?'':formatearFechaMoment_a_String(this.state.fechaConfirmacion);
        let fechaEmbarque = this.state.fechaEmbarque===null?'':formatearFechaMoment_a_String(this.state.fechaEmbarque);
        let fechaAduana = this.state.fechaAduana===null?'':formatearFechaMoment_a_String(this.state.fechaAduana);
        let fechaRecepcion = this.state.fechaRecepcion===null?'':formatearFechaMoment_a_String(this.state.fechaRecepcion);
       
        if(validarFechaMomentEnFormatoString(fechaConfirmacion) && validarFechaMomentEnFormatoString(fechaEmbarque) && validarFechaMomentEnFormatoString(fechaAduana) && validarFechaMomentEnFormatoString(fechaRecepcion) ){
            this.setState({isOpen: !this.state.isOpen},()=>{
                //Limpiar parametros de la fecha al salir
                this.clearModal();
            });
        }else{
            alert('Existen fechas faltantes');
        }
    }

    clearModal(){
        this.setState({selectFecha_sel: null, fechaSeleccionada_sel: null, cantidadDias: 0, procentaje: 0})
    }

    addFormaPago(){
        var acc=0;
        acc = this.control_porcentaje_pago(this.state.dataModalFormaPago);
        
        var porcentaje_pg = 0;
        porcentaje_pg = parseInt(this.state.procentaje,10)

        var totalProcentajeIngreso = acc+porcentaje_pg
        if(acc>=100){
            alert("El porcentaje de pago ya cumple el 100%");
        }else if (this.state.selectFecha_sel === null){
            alert('Ud. no ha seleccionado el tipo de fecha a añadir.');
        }else if (parseInt(this.state.cantidadDias, 10)<0){    
            alert('Ud. no ha indicado la cantidad de dias referente al pago.');      
        }else if (totalProcentajeIngreso>100){ 
            alert('Ud. no ha indicado el porcentaje de pago o este excede el 100%.');
        }else{
            
            var subtotal = 0;
            var fechaSumada;
            var item_pago = {};

            this.state.dataModalFormaPago.forEach((item)=>{
                subtotal = item.subtotal + subtotal
            });

            item_pago.tipo_fec = parseInt(this.state.selectFecha_sel.value, 10)
            let index_final = this.state.dataModalFormaPago.length - 1;
            let nro_item = 0;

            if(index_final===-1){
                 nro_item = 1
            }else{
                nro_item = parseInt(this.state.dataModalFormaPago[index_final].secuencia, 10)+1;
            }

            item_pago.secuencia= completar_String(nro_item, '0', 3);
            item_pago.descripcion= parseInt(this.state.selectFecha_sel.value, 10)===1?"FECHA CONFIRMACIÓN":"FECHA EMBARQUE";
            item_pago.fecha = formatearFechaMoment_a_String(this.state.fechaSeleccionada_sel);
            
            if(parseInt(this.state.selectFecha_sel.value,10)===1){
                let fechaConfirmacion = moment(formatearFechaMoment_a_String(this.state.fechaConfirmacion),'DD/MM/YYYY')
                fechaSumada = fechaConfirmacion.add(parseInt(this.state.cantidadDias, 10), 'days')
            }else{
                let fechaEmbarque = moment(formatearFechaMoment_a_String(this.state.fechaEmbarque),'DD/MM/YYYY')
                fechaSumada = fechaEmbarque.add(parseInt(this.state.cantidadDias, 10), 'days')
            }
            
            item_pago.fecha_pago = formatearFechaMoment_a_String(fechaSumada)
            item_pago.dias_plazo = parseInt(this.state.cantidadDias, 10);
            item_pago.porcentaje = parseInt(this.state.procentaje, 10);
            item_pago.estado = 'A'
            
            var total = this.getTotalArticulo();
            var resp;

            resp = (total*parseInt(item_pago.porcentaje, 10))/100;
            item_pago.fob_base = resp.toFixed(2);
            
            this.setState({ dataModalFormaPago: this.immutablePush(this.state.dataModalFormaPago, item_pago)})
        }
    }

    fixInputNumber(event){
        const target = event.target;       
        const name = target.name;    
        var value = target.value;

        if(value===''){
            value = 0;
        }

        this.setState({
          [name]: value
        });
    }

    getTotalArticulo(){
        var total = 0;
        this.state.dataArticulos.forEach((ART)=>{
            if(ART.hasOwnProperty('subtotal')===true){
                total = total + parseFloat(ART.subtotal,10);
            }
        })
        total = Math.round(total*100)/100
        return total
    }

    //Retorna el porcentaje de pago actual en el array
    control_porcentaje_pago(arr){
        var acc=0;
        console.log("ARRAY: ", arr)
        arr.forEach((data)=>{
            acc = acc + parseInt(data.porcentaje,10);
        })
        return acc;
    }

    //Operations GRID
    eliminar(datos_fila, id ){
        var e = {};
        e.localidad = '01';
        e.secuencia = datos_fila.secuencial;
        this.setState({ dataArticulos: this.immutableDelete(this.state.dataArticulos, id) },()=>{
            let total = this.getTotalArticulo();
            this.setState({valorFob: Math.round(total*100)/100})
        })
    }

    eliminarFormaPago(datos_fila ,id){        
        this.setState({dataModalFormaPago: this.immutableDelete(this.state.dataModalFormaPago, id)})
    }

    immutablePush(array, newItem){
        return [ ...array, newItem ];  
    }

    immutableDelete (arr, index) {
        var i = parseInt(index, 10);
        return arr.slice(0,i).concat(arr.slice(i+1));
    }

    methodFromParent(id, datos_fila){

        var mensaje;
        if(datos_fila.arancel!=="" && datos_fila.dias_plazo===undefined){
            mensaje = window.confirm("¿Desea eliminar el registro?"); 
            if (mensaje){
                this.eliminar(datos_fila ,id ) 
            } 
        }else if(datos_fila.descripcion!=="" && datos_fila.arancel===undefined){
            mensaje = window.confirm("¿Desea eliminar el registro?"); 
            if (mensaje){
                this.eliminarFormaPago(datos_fila ,id) 
            }
        }
    }

    //ASYNC LOAD
    getOptions_Proveedores(input, callback){
        if (input.toString().length >= 2 ){
            let cadena_busq = '&cadena_busq=' + input;
            cargarCatalogosGenericoAsync('/proveedores?tipo=catalogo', cadena_busq, callback)
        }
    }

    getOptions_Articulos(input, callback){
        if (input.toString().length >= 2 ){
            let query = "?tipo=catalogo&cadena_busq=" + input;     
            cargarCatalogosGenericoAsync('/articulos', query, callback)
        }
    }

    //REACT CYCLE
    componentDidMount(){
        Promise.all([ 
            cargarCatalogos_Otros('GEN-PLANVIG'), cargarCatalogos_Otros('IMP-FECHAS'),
            obtenerSecuencial('Importacion'),
            this.props.generar_LogAuditoriaIngresoForm('0312'), ])
        .then(([r_planVigente, r_tipofecha, secImportacion]) => {
            let fechaProceso = getFechaProcesoPorModulo('03');
            let fechaConfirmacion = moment(fechaProceso, "DD/MM/YYYY");

            this.setState({ planVigente: r_planVigente[0].value, optFechasPago: r_tipofecha,
            secuenciaId: completar_String(secImportacion.codigo,'0',6), 
            fecha_proceso: moment(fechaProceso,'DD/MM/YYYY'), 
            permiso: this.props.permiso.toString(),fechaConfirmacion: fechaConfirmacion, 

            })
        });
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0312');
    }

    render(){
        return (
            <ContenedorForm porc_ancho={80}>
            <HeaderForm>
                <TituloForm>Importaciones Manuales</TituloForm>
            </HeaderForm>
                <CuerpoForm>
                    <ContainerEdit>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Movimiento:</LabelForm>
                            <InputText ancho="60" name="secuenciaId" disabled={true} value={this.state.secuenciaId}/>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2 col-sm-offset-8'>
                            <LabelForm>Fecha:</LabelForm>                            
                            <PickerFecha fechaSeleccionada={this.state.fecha_proceso} disabled={!(this.props.permiteCambioFProceso==='S')} func_onChange={(fechaEscogida)=>{this.setState({fecha_proceso: fechaEscogida})}}/>
                        </ContainerCol>
                    </ContainerEdit>
                    <Row>
                        <ContainerCol className='col-sm-4'>
                            <LabelForm>Proveedor:</LabelForm>
                            <ReactSelectAsync value={this.state.proveedor_sel} func_loadOptions={this.getOptions_Proveedores} func_onChange={(value)=>{this.setState({proveedor_sel: value})}} func_onBlur={this.asignarCuentaProveedor}/>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Confirmación:</LabelForm>                            
                            <PickerFecha fechaSeleccionada={this.state.fechaConfirmacion}  func_onChange={(fechaEscogida)=>{this.setState({fechaConfirmacion: fechaEscogida})}}/>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Embarque:</LabelForm>                            
                            <PickerFecha fechaSeleccionada={this.state.fechaEmbarque} func_onChange={(fechaEscogida)=>{this.setState({fechaEmbarque: fechaEscogida})}}/>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Llegada Aduana:</LabelForm>                            
                            <PickerFecha fechaSeleccionada={this.state.fechaAduana} func_onChange={(fechaEscogida)=>{this.setState({fechaAduana: fechaEscogida})}}/>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Recepción Oficina:</LabelForm>                            
                            <PickerFecha fechaSeleccionada={this.state.fechaRecepcion} func_onChange={(fechaEscogida)=>{this.setState({fechaRecepcion: fechaEscogida})}}/>
                        </ContainerCol>
                    </Row>
                    <Row>                        
                        <ContainerCol className='col-sm-4'>
                            <LabelForm>Articulo:</LabelForm>
                            <ReactSelectAsync func_ref={ref=>{this.asyncRef = ref}} value={this.state.articulo_sel} func_loadOptions={this.getOptions_Articulos} func_onChange={(value)=>{this.setState({articulo_sel: value})}}/>
                        </ContainerCol> 
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Cantidad:</LabelForm>
                            <InputText name="cantidad" type="number" value={this.state.cantidad} onChange={this.actualizarCampos} maxLength="3"/>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>PrecioFOB:</LabelForm>
                            <InputText name="pFob" value={this.state.pFob} onChange={this.actualizarCampos} maxLength="7"/>
                        </ContainerCol>
                        <ContainerCol className='col-sm-1' margen_arriba="23">
                            <Button className='btn btn-success btn-sm' onClick={this.addItems}><i className="fa fa-plus"/></Button>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-md-10'>
                            <AgGridRender altura='150px' data={this.state.dataArticulos} columnas={this.state.columnDefsArticulos} gridOptions={this.articulosOptions} onGridReady={this.onGridArticulosReady}/>                                                           
                        </ContainerCol>
                        <ContainerCol className='col-md-2'>
                            <LabelForm>ValorFOB: {this.state.valorFob}</LabelForm>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <div className='col-sm-12'>
                            <div className='btn-group pull-right'>
                                <button type='button' className='btn btn-primary btn-sm' disabled={this.state.cuentaProveedor===null?true:false} onClick={this.guardarImportacion}><i className='fa fa-floppy-o fa-lg'/> Guardar</button>
                                <button type="button" className='btn btn-info btn-sm' disabled={this.state.dataArticulos.length>0?false:true} onClick={this.toggleModal}><i className="fa fa-credit-card-alt"></i> Forma de pago</button>
                                <button type='button' className='btn btn-sm' onClick={()=>{this.limpiarPantalla()}}><i className='fa fa-trash-o fa-lg'/> Limpiar</button>
                            </div>
                        </div>
                    </Row>
                </CuerpoForm>
                {/*MODAL FORMA DE PAGO*/}
                <ModalResponsive open={this.state.isOpen} ocultarClose={false} onClose={()=>{this.setState({isOpen:false})}}>
                    <HeaderForm>
                        <TituloForm>Forma de pago</TituloForm>
                    </HeaderForm>
                    <CuerpoForm>
                        <ContenedorModal>
                            <Row>
                                <ContainerCol className='col-sm-3'>
                                    <LabelForm>Tipo:</LabelForm>
                                    <ReactSelect options={ this.state.optFechasPago } value={this.state.selectFecha_sel} func_onChange={(value)=>{this.setState({selectFecha_sel: value})}} func_onBlur={this.setFormaPago}/>
                                </ContainerCol>
                                <ContainerCol className='col-sm-2'>
                                    <LabelForm>Fecha:</LabelForm>
                                    <PickerFecha fechaSeleccionada={this.state.fechaSeleccionada_sel} disabled={true} func_onChange={(fechaEscogida)=>{this.setState({fechaSeleccionada_sel: fechaEscogida})}}/>
                                </ContainerCol>
                                <ContainerCol className='col-sm-2'>
                                    <LabelForm>Dias:</LabelForm>
                                    <InputText name="cantidadDias" type="number" value={this.state.cantidadDias} onChange={this.actualizarCampos} maxLength="3" onBlur={(value)=>this.fixInputNumber(value)}/>
                                </ContainerCol>
                                <ContainerCol className='col-sm-2'>
                                    <LabelForm>Porcentaje:</LabelForm>
                                    <InputText name="procentaje" type="number" value={this.state.procentaje} onChange={this.actualizarCampos} maxLength="3" onBlur={(value)=>this.fixInputNumber(value)}/>
                                </ContainerCol>
                                <ContainerCol className='col-sm-2' margen_arriba="23">
                                    <button type="button" className='btn btn-success btn-sm' onClick={this.addFormaPago}><i className="fa fa-plus"></i> Añadir</button>
                                </ContainerCol>                                       
                            </Row>
                            <Row>
                                <div className='col-md-12'>
                                    <AgGridRender altura='140px' data={this.state.dataModalFormaPago} columnas={this.state.columnFormaPago} gridOptions={this.formPagoOptions} onGridReady={this.onGridFormaPagoReady}/>                                                           
                                </div>
                            </Row>
                            <Row>
                                <div className='col-md-12'>
                                    <div className="btn-group pull-right">                                       
                                        <button type="button" className='btn btn-sm' /*disabled={this.state.dataModalFormaPago.length>0?false:true}*/ onClick={this.toggleModal}>
                                            <i className="fa fa-times-circle"></i> Cerrar
                                        </button>                                                
                                    </div>                                     
                                </div>
                            </Row>                              
                        </ContenedorModal>
                    </CuerpoForm>
                </ModalResponsive>
            </ContenedorForm>
        )
    }
}

const mapStateToProps = ((state) => {
    return {puntoFacturacionSel: state.ventas.ptoFacturacionSel, 
            permiso: state.sesion.valoresSesionForm.Permiso,
            usuario: state.sesion.valoresSesionForm.Usuario,
            IdRegAudit: state.sesion.valoresSesionForm.IdRegAudit,
            departamento : state.sesion.valoresSesionForm.Departamento,
            permiteCambioFProceso: state.sesion.valoresSesionForm.CambioFechaProceso,
            diasPermiteCambioFProceso: state.sesion.valoresSesionForm.CantidadDias}
  });
  
  const mapDispatchToProps = ((dispatch) => {  
    return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm,
                                cambiar_VisualizacionLoading }, dispatch)
  });
  
  export default connect (mapStateToProps, mapDispatchToProps)(FormImport12);